import LoginPage from './login'

export default [
  {
    Component: LoginPage,
    title: 'Login Page',
    path: '*'
  }
]
